import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useNewProjectService, useNewProjectUrl } from 'domain/shared/newProject';
import { useParams } from 'react-router-dom';
import { useAsyncValue } from 'framework/utils';

const ProjectFinanceBreadcrumbs = ({
  children = null,
  projectId,
}: {
  children?: React.ReactNode | React.ReactNode[] | null;
  projectId?: string;
}) => {
  const { getFinanceUrl } = useNewProjectUrl();
  const { id } = useParams();
  const { getById } = useNewProjectService();
  const project = useAsyncValue(() => getById(projectId || id!));

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity={project?.name} link={getFinanceUrl(projectId || id!)} />
      {children}
    </Breadcrumbs>
  );
};

export default ProjectFinanceBreadcrumbs;
